import { extractData } from '@/models';
import type {
    BuyCryptoQuote,
    RequestBuyCryptoQuote,
    RequestSellCryptoQuote,
    RequestSwapCryptoQuote,
    SellCryptoQuote,
    SwapCryptoQuote,
} from '@kano/types';

import client from '../../assets/js/services/api';

const apiUrl = PROCESSING_API_URL;

export default {
    listBuyCryptoQuote(payload: RequestBuyCryptoQuote) {
        return client
            .post<BuyCryptoQuote>(`${ apiUrl }/public/processing/v2/quote/buy-crypto`, payload)
            .then(extractData);
    },

    listSellCryptoQuote(payload: RequestSellCryptoQuote) {
        return client
            .post<SellCryptoQuote>(`${ apiUrl }/public/processing/v2/quote/sell-crypto`, payload)
            .then(extractData);
    },

    listSwapCryptoQuote(payload: RequestSwapCryptoQuote) {
        return client
            .post<SwapCryptoQuote>(`${ apiUrl }/public/processing/v2/quote/swap-crypto`, payload)
            .then(extractData);
    },
};
